export type FreePlayPhase = 'idle' | 'playing' | 'voting';

export type VoteChoice = 'yes' | 'no';

export type VoteContext = {
    initiatorID: string;
    proposedGameID: string;
    eligibleVoters: string[];
    startedAt: number;
    deadline: number;
    votes: Record<string, VoteChoice>;
};

export type VoteOutcome = {
    /** How the vote settled. 'expired' is a soft rejection (deadline reached, no majority). */
    result: 'accepted' | 'rejected' | 'expired';
    initiatorID: string;
    proposedGameID: string;
    at: number;
};

export type FreePlayState = {
    phase: FreePlayPhase;
    currentGameID: string | null;
    vote: VoteContext | null;
    initiatorCooldowns: Record<string, number>;
    /** Last settled vote, used for the result feedback shown to everyone (TV banner +
        toast on every gamepad) and the proposer's cooldown messaging. */
    lastVoteOutcome?: VoteOutcome | null;
};

export type VoteResult = 'pending' | 'accepted' | 'rejected' | 'expired';

export type StartVoteAttempt =
    | { ok: true; state: FreePlayState }
    | { ok: false; reason: 'wrong_phase' | 'same_game' | 'cooldown' | 'no_active_players' };

export const FP_STATE_KEY = 'freePlay/state';

export const FP_ACTION_REQUEST_START = 'freePlay/requestStart';
export const FP_ACTION_REQUEST_CHANGE = 'freePlay/requestChange';
export const FP_ACTION_CAST_VOTE = 'freePlay/castVote';

export type RequestStartPayload = { gameID: string };
export type RequestChangePayload = { gameID: string };
export type CastVotePayload = { vote: VoteChoice };

export const FP_DEFAULTS = {
    voteDurationMs: 30_000,
    initiatorCooldownMs: 30_000,
    /** How long the vote-result feedback (TV banner + gamepad toasts) stays visible. */
    voteResultMs: 5_000,
    /** Idle grace before the first-game selector opens to every gamepad (fallback when
        the first-connected player never picks). */
    chooserFallbackMs: 12_000,
} as const;
